import { FilterMatchMode, FilterOperator } from '@primevue/core/api'
import type GridConfiguration from '../types/GridConfiguration'

export const FinancedDealsConfiguration: GridConfiguration = {
  columns: [
    {
      field: 'customer',
      header: 'Customer Name',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'proposal_date',
      header: 'Proposed Date',
      type: 'date',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
    },
    {
      field: 'funded_date',
      header: 'Paid Date',
      type: 'date',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
    },
    {
      field: 'agreement_number',
      header: 'Contract',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'agreement_type',
      header: 'Product Type',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'financed_amount',
      header: 'Deal Value',
      type: 'currency',
    },
    {
      field: 'reg_no',
      header: 'Registration',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'new_used',
      header: 'New/Used',
      type: 'text',
      filter: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    },
    {
      field: 'commission_amount_without_tax',
      header: 'Commission',
      type: 'currency',
    },
    {
      field: 'pays_value',
      header: 'PB',
      type: 'currency',
    },
    {
      field: 'b2b_pays_value',
      header: 'B2B',
      type: 'currency',
    },
  ],
  settings: [
    { name: 'showDownloadDocument', value: false },
    { name: 'showDownloadSpreadsheet', value: true },
    { name: 'showMonthFilter', value: false },
    { name: 'showYearFilter', value: true },
    { name: 'showColumnSelect', value: true },
    { name: 'sortField', value: 'funded_date' },
  ],
}
